import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-svg-icon',
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SvgIconComponent {
  @Input() svgIcon: string = '';
  @Input() customClass: string = '';

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['svgIcon'] && this.svgIcon) {
      this.iconRegistry.addSvgIcon(
        this.svgIcon,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `assets/icones/${this.svgIcon}.svg`
        )
      );
    }
  }

  get svgIconClass(): string {
    return this.customClass
      ? `${this.customClass} icon-${this.svgIcon.replace(
          /[^a-zA-Z0-9_-]/g,
          '-'
        )}`
      : `icon-${this.svgIcon.replace(/[^a-zA-Z0-9_-]/g, '-')}`;
  }
}
